import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/footer/Logo Feder.jpg")